import { Component, ErrorInfo, ReactNode } from 'react';
import styled from 'styled-components';
import { theme } from '../styles/GlobalStyles';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  padding: 2rem;
  text-align: center;

  h2 {
    color: ${theme.primaryDark};
    margin-bottom: 1rem;
  }

  p {
    color: ${theme.textLight};
    margin-bottom: 1.5rem;
  }

  button {
    background-color: ${theme.primaryDark};
    color: ${theme.white};
    border: none;
    border-radius: 4px;
    padding: 0.75rem 1.5rem;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: ${theme.primary};
    }
  }
`;

class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, info);
  }

  handleReset = () => {
    // Full reload: re-rendering children would immediately re-throw
    // for persistent errors, making a plain reset appear broken.
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorContainer>
          <h2>Jotain meni pieleen</h2>
          <p>Sivun lataaminen epäonnistui. Yritä päivittää sivu.</p>
          <button onClick={this.handleReset}>Yritä uudelleen</button>
        </ErrorContainer>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
